module.exports = __webpack_public_path__ + "static/media/MB-icon-new.bf7a0a6d.png";